var dict = require("./dict");

module.exports = Object.keys(dict);
